<template>
  <div class="row">
    <div class="col-md-12">
      <div class="info-table" style="justify-content: flex-end">
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="busca-ativa"
          >
          </download-files>
        </div>
      </div>
      <TabelaCadastrosVuetify
        ref="table"
        :cadastros="displayedCadastros"
        :data_secretaria_de_saude="ultimaAtualizacao"
        texto_esus_pec="Procedimentos registrados até"
        :data_esus_pec="ultimaAtualizacao"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      />
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import * as Functions from './functions.js'
import TabelaCadastrosVuetify from './TabelaCadastrosVuetify.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'BuscaAtiva',
  components: {
    TabelaCadastrosVuetify,
    DownloadFiles,
  },
  mixins: [utils],

  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipes: [],
      equipe: '',
      profissionais: [],
      profissional: '',
      cadastros: [],
      page: 1,
      perPage: 12,
      pages: [],
      nome: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeProfissional: '',
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    // Busca os dados referentes a cidade ao abrir a página
    async buscarDadosBuscaAtiva() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.cod_ibge,
          id: this.user_id,
        })
        if (user) {
          this.nomeProfissional = user.data.nome
          let response = await this.$api.get(
            '/app/busca-ativa/acs/' + this.cod_ibge + '/' + user.data.cpf
          )
          this.cadastros = []
          this.cadastros = response.data
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        '',
        '',
        this.nomeProfissional
      )
    },
    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarDadosBuscaAtiva()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
